const TiktokIcon = ({ size = 28, className = "flex-shrink-0" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" aria-label="TikTok" role="img" viewBox="0 0 512 512" width={size} height={size} className={className}>
      <path d="M237 215a117 117 0 1 0 101 115V202a150 150 0 0 0 88 28v-63a88 88 0 0 1-88-88h-64v252a54 54 0 1 1-37-51z" fill="#f05" style={{ mixBlendMode: "multiply" }} />
      <path d="M219 200a117 117 0 1 0 101 115V187a150 150 0 0 0 88 28v-63a88 88 0 0 1-88-88h-64v252a54 54 0 1 1-37-51z" fill="#0ee" style={{ mixBlendMode: "multiply" }} />
    </svg>
  );
  
  
  export default TiktokIcon;
  